export const isQuadraticBezier = (path) => path.quadratic !== undefined;
export const isCubicBezier = (path) => path.cubic1 !== undefined && path.cubic2 !== undefined;
